import React, { useEffect, useState } from 'react';
import { CircularProgress, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { getRedirectParams } from '../../requests/get-redirect-params';
import { ROUTES } from '../../../../../shared/constants/routes';

const ConversationRedirect = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { chatId } = useParams<{
    chatId: string;
  }>();

  const fetchRedirectParams = async () => {
    if (!chatId) {
      navigate(ROUTES.DASHBOARD);
      return;
    }
    setLoading(true);
    try {
      const response = await getRedirectParams(chatId);
      const { wabaNumber, customerNumber } = response;
      if (wabaNumber == null) {
        navigate(`${ROUTES.CONVERSATIONS}`);
        return;
      }
      navigate(`${ROUTES.CONVERSATIONS}/${wabaNumber}/${customerNumber}`);
    } catch (err) {
      if (err) {
        navigate(`${ROUTES.CONVERSATIONS}`);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRedirectParams();
  }, [chatId]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <CircularProgress />
        <Typography variant="body1">Loading...</Typography>
      </div>
    );
  }

  return null;
};

export default ConversationRedirect;
